<template>
  <div class="confirm">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div v-if="withdrawalData&&withdrawalData.amount" class="layout">
        <div v-if="withdrawalData.isUSDT" class="amount">
          <p>提现金额（美元）</p>
          <span>${{ withdrawalData.amount }}</span>
        </div>
        <div v-else class="amount">
          <p>提现金额（人民币）</p>
          <!-- <span>¥{{ Math.floor(parseFloat(withdrawalData.amount * withdrawalData.rate)) }}</span> -->
          <span>¥{{ withdrawalData.amount }}</span>
        </div>
        <div class="orderList">
          <ul>
            <li>
              <p>提现至</p>
              <span v-if="!withdrawalData.isUSDT">{{ withdrawalData.withdrewBankNameInCh }}(尾号{{
                (withdrawalData.withdrewBankAccount).replace(/^(\d{0})\d+(\d{4})$/, "$2") }})</span>
              <span v-else>
                {{ withdrawalData.protocol }}
                {{ withdrawalData.walletAddress.substring(0, withdrawalData.walletAddress.length -
                4).replace(/\d|\w/g,'*').replace(/(.{4})/g,"$1 ") }}
                {{ withdrawalData.walletAddress.slice(-4) }}
              </span>
            </li>
            <li>
              <p>提现金额</p>
              <span v-if="!withdrawalData.isUSDT">
                {{ Math.round(Number(withdrawalData.amount) / withdrawalData.rate * 100) / 100 }} 美元
              </span>
              <span v-else>
                {{ Number(withdrawalData.amount).toFixed(2) }} 美元
              </span>
            </li>
            <li class="red">
              <p>手续费</p><span>{{ withdrawalData.fee }} 美元</span>
            </li>
            <li v-if="withdrawalData.isUSDT">
              <p>实际到账金额</p><span>{{
                parseFloat(withdrawalData.rate*(withdrawalData.amount-withdrawalData.fee)).toFixed(2) }} {{
                !withdrawalData.isUSDT ? "人民币":"USDT" }}（仅供参考）</span>
            </li>
            <li v-else>
              <p>实际取款金额</p><span>{{ Math.round(Number(withdrawalData.amount+withdrawalData.fee * withdrawalData.rate)/withdrawalData.rate *
                100) / 100 }} 美元</span>
            </li>
          </ul>
        </div>
        <div class="submit" @click="submit"><span>确认提现</span></div>
        <div class="errMessage">
          <p>{{ errMessage }}</p>
        </div>
      </div>
      <Chat />
    </div>
  </div>
</template>

<script>
require('@/assets/css/confirm.css')
import Header from '@/view/module/Header.vue'
import Chat from '@/view/module/Chat.vue'
import api from '@/plugins/api'
import utils from '@/utils/tradeDataUtil'
import { mapState } from 'vuex'
export default {
  name: 'WithdrawalConfirm',
  components: { Header, Chat },
  computed: {
    ...mapState(['user', 'platform', 'withdrawalData', 'gts2AccountId', 'pageType'])
  },
  data() {
    return {
      title: '确认提现',
      rightContent: 'withdrawal',
      errMessage: ''
    }
  },
  mounted() {
    console.log(this.withdrawalData)
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    submit() {
      this.$bus.$emit('loading', false)
      const { isUSDT, amount, fee, rate, ...rest } = this.withdrawalData
      
      const readyData = rest
      api.addWithdraw(readyData).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            this.$fireBase.logEvent('withdraw_second', {
              'platform_type': this.pageType == 'app' ? 'app端' : this.pageType == 'trade' ? 'H5交易' : '用户中心',
              'bank_type': this.bankName,
              'time': utils.getThisTime(),
              'withdraw_amount': this.withdrawalData.amount,
              'real_amount': Number(this.withdrawalData.rate * this.withdrawalData.amount).toFixed(2),
              'url': window.location.href,
              'is_success': 'true'
            })
            this.$router.replace({ path: '/home/WithdrawalResult' })
          } else {
            this.$bus.$emit('loading', true)
            this.errMessage = res.data.code_desc
            this.$fireBase.logEvent('withdraw_second', {
              'platform_type': this.pageType == 'app' ? 'app端' : this.pageType == 'trade' ? 'H5交易' : '用户中心',
              'bank_type': this.bankName,
              'time': utils.getThisTime(),
              'withdraw_amount': this.withdrawalData.amount,
              'real_amount': Number(this.withdrawalData.rate * this.withdrawalData.amount).toFixed(2),
              'url': window.location.href,
              'is_success': 'false'
            })
          }
        }
      })
    }
  }
}
</script>
